import script from "./index-web.vue?vue&type=script&setup=true&lang=ts"
export * from "./index-web.vue?vue&type=script&setup=true&lang=ts"

import "./index-web.vue?vue&type=style&index=0&id=38121c0a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38121c0a"]])

export default __exports__